<template>
    <div class="columns is-multiline is-centered p-4">
        <div
            class="
                column
                is-offset-5 is-6 is-inline-flex is-justify-content-right
            "
        >
            <div class="field has-addons mr-3">
                <div class="control">
                    <DatePicker
                        v-model="date"
                        minDate="29/08/2022"
                        :maxDate="maxDate"
                        :remove="false"
                    />
                </div>
                <div class="control">
                    <button
                        class="button is-primary ml-3"
                        @click="downloadReport"
                        :disabled="isDownloading"
                    >
                        <Icon family="fal" name="fa-download" />
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-11 has-text-centered" v-if="isLoading">
            <h5 class="has-text-primary has-text-weight-bold">
                Se esta cargando la información ...
            </h5>
            <Loading />
        </div>
        <div class="column is-11 is-inline-flex" v-else>
            <table class="table is-striped is-hoverable is-fullwidth">
                <thead class="is-size-7">
                    <tr>
                        <th></th>
                        <th>{{ sum("starters") }}</th>
                        <th>{{ sum("waiting") }}</th>
                        <th>{{ sum("replied") }}</th>
                        <th>{{ sum("repliedBeforeTwentySeconds") }}</th>
                        <th>{{ sum("repliedAfterTwentySeconds") }}</th>
                        <th>{{ sum("abandoned") }}</th>
                        <th>{{ sum("abandonedBeforeTwentySeconds") }}</th>
                        <th>{{ sum("abandonedAfterTwentySeconds") }}</th>
                        <th>{{ sumTime("talkTime") }}</th>
                        <th>{{ avgTime("averageTalkTime") }}</th>
                        <th>{{ avg("abandonedPercent") }}%</th>
                    </tr>
                    <tr>
                        <th>Intervalo</th>
                        <th>LLamadas entrantes</th>
                        <th>Llamadas en espera</th>
                        <th>LLamadas contestadas</th>
                        <th>LLamadas contestadas antes de 20 seg.</th>
                        <th>LLamadas contestadas despues de 20 seg.</th>
                        <th>LLamadas abandonadas</th>
                        <th>LLamadas abandonadas antes de 20 seg.</th>
                        <th>LLamadas abandonadas despues de 20 seg.</th>
                        <th>Tiempo total de conversación</th>
                        <th>Tiempo promedio conversación AHT</th>
                        <th>Abandono %</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in items" :key="row.interval">
                        <td>{{ row.interval }}</td>
                        <td>{{ row.starters }}</td>
                        <td>{{ row.waiting }}</td>
                        <td>{{ row.replied }}</td>
                        <td>{{ row.repliedBeforeTwentySeconds }}</td>
                        <td>{{ row.repliedAfterTwentySeconds }}</td>
                        <td>{{ row.abandoned }}</td>
                        <td>{{ row.abandonedBeforeTwentySeconds }}</td>
                        <td>{{ row.abandonedAfterTwentySeconds }}</td>
                        <td>{{ row.talkTime }}</td>
                        <td>{{ row.averageTalkTime }}</td>
                        <td>{{ row.abandonedPercent }}%</td>
                    </tr>
                    <tr v-if="items.length === 0">
                        <td align="center" colspan="14">No hay registros...</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";

import moment from "moment";
import DatePicker from "@/components/external-components/datepicker/DatePicker";
import Loading from "@/components/Loading.vue";

export default {
    name: "interval-report",
    components: {
        DatePicker,
        Loading,
    },
    data() {
        return {
            isLoading: true,
            items: [],

            maxDate: null,
            date: null,

            isDownloading: false,
        };
    },
    mounted() {
        var today = moment().format("DD/MM/YYYY");
        this.date = today;
        this.maxDate = today;
    },
    watch: {
        date() {
            this.getItems();
        },
    },
    methods: {
        async getItems() {
            this.isLoading = true;
            try {
                let date = moment(this.date, "DD/MM/YYYY").format(
                    "YYYY-MM-DDTHH:mm:ss"
                );
                let response =
                    await RepositoryFactory.reports.getIntervalReportBase({
                        date: date,
                    });

                let items = response.data.items;
                this.parseItems(items);
                this.items = items;
            } catch (error) {
                window.console.log(error);
            }
            this.isLoading = false;
        },
        downloadReport() {
            this.isDownloading = true;
            let rows = [
                [
                    "Intervalo",
                    "Llamadas entrantes",
                    "Llamadas en espera",
                    "LLamadas contestadas",
                    "LLamadas contestadas antes de 20 seg.",
                    "LLamadas contestadas despues de 20 seg.",
                    "LLamadas abandonadas",
                    "LLamadas abandonadas antes de 20 seg.",
                    "LLamadas abandonadas despues de 20 seg.",
                    "Tiempo total de conversación",
                    "Tiempo promedio conversación AHT",
                    "Abandono %",
                ],
            ];
            for (const item of this.items) {
                let row = [
                    item.interval,
                    item.starters,
                    item.waiting,
                    item.replied,
                    item.repliedBeforeTwentySeconds,
                    item.repliedAfterTwentySeconds,
                    item.abandoned,
                    item.abandonedBeforeTwentySeconds,
                    item.abandonedAfterTwentySeconds,
                    item.talkTime,
                    item.averageTalkTime,
                    item.abandonedPercent,
                ];
                rows.push(row);
            }

            let csvContent =
                "data:text/csv;charset=utf-8," +
                rows.map((e) => e.join(";")).join("\n");

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "Report.csv");
            document.body.appendChild(link);
            link.click();

            this.isDownloading = false;
        },
        sum(name) {
            var sum = 0;
            for (const item of this.items) {
                sum += item[name];
            }
            return sum;
        },
        timeToSecs(time) {
            var parts = time.split(":");
            return (
                parseInt(parts[0]) * 3600 +
                parseInt(parts[1]) * 60 +
                parseInt(parts[2])
            );
        },
        secsToTime(secs) {
            let hours = Math.floor(secs / 3600)
                .toString()
                .padStart(2, "0");
            let minuts = (Math.floor(secs / 60) % 60)
                .toString()
                .padStart(2, "0");
            let seconds = (secs % 60).toString().padStart(2, "0");
            return [hours, minuts, seconds].join(":");
        },
        sumTime(name) {
            var sum = 0;
            for (const item of this.items) {
                sum += this.timeToSecs(item[name]);
            }
            return this.secsToTime(sum);
        },
        avgTime(name) {
            var sum = 0;
            var count = 0;
            for (const item of this.items) {
                if (item[name] !== "00:00:00") {
                    sum += this.timeToSecs(item[name]);
                    count++;
                }
            }
            if (count === 0) {
                return "00:00:00";
            }
            var avg = Math.round(sum / count);
            return this.secsToTime(avg);
        },
        avg(name) {
            var sum = 0;
            var count = 0;
            for (const item of this.items) {
                if (item[name] > 0) {
                    sum += item[name];
                    count++;
                }
            }
            if (count === 0) {
                return 0;
            }
            var avg = Math.round((sum / count) * 100);
            return avg / 100;
        },
        parseItems(items) {
            for (const item of items) {
                if (item.abandoned === 0 || item.starters === 0) {
                    item.abandonedPercent = 0;
                } else {
                    let percent = (item.abandoned * 100) / item.starters;
                    item.abandonedPercent = Math.round(percent);
                }
                item.averageTalkTime = this.parseTime(item.averageTalkTime);
            }
        },
        parseTime(time) {
            if (time === null) {
                return "-";
            }
            var dots = (time.match(/\./g) || []).length;
            if (dots === 1) {
                return time.split(".")[0];
            } else if (dots === 2) {
                return time.split(".")[1];
            }
            return time;
        },
    },
};
</script>